import type { StatusBannerView } from '~/features/my-wallet/types/status-banner'
import { buildStatusBannerView } from '~/features/my-wallet/utils/status-banner'
import { useMyWalletScreenState } from './useMyWalletScreenState'

/** Reuses the tabs' query (same cache key, no extra request); only shown in the `ready` state. */
export function useWalletStatusBanner() {
  const { paymentModel, screenState } = useMyWalletScreenState()

  const statusBanner = computed<StatusBannerView | null>(() =>
    screenState.value === 'ready' && paymentModel.value ? buildStatusBannerView(paymentModel.value) : null,
  )

  return { statusBanner }
}
